<template>
	<page enable-flex>
		<view-list ref="view" work-type="2" :custom-view="{
			name: '服务评价',
			tabs: evaluateTypeDic,
			tabParam: val => ({evaluate_state: val.toString() ? [val] : [0, 1]})
		}" :search="false">
			<template #default="{data, index}">
				<view-list-card :key="index" :data="data" @click="mp.navigateWeb('/aftersales/work/detail', {id: data.id})">
					<template #base>
						<div class="card-base-info flex">
							<div class="flex-grow">
								<div class="state flex">
									<c-state dict="serviceTypeDic" tag :value="data.service_type"></c-state>
									<c-state dict="evaluateTypeDic" tag :value="data.evaluate_state"></c-state>
									<div v-if="data.service_score" class="flex-grow flex-end-center" style="gap: .08rem; font-size: .26rem;">
										<ins v-for="(item, i) in data.service_score" :key="i" style="color: #FF6900;">
											<i class="tf">&#xe71e;</i>
										</ins>
									</div>
								</div>
								<p class="title">{{data.customer_name}}</p>
							</div>
						</div>
					</template>

					<template #content>
						<c-field icon="tf-field" label="工单编号">{{data.order_number}}</c-field>
						<c-field icon="tf-field" label="负责人">{{data.charge_user_realname}}</c-field>
						<c-field icon="tf-field" label="参与人">{{data.group_user_realname ? data.group_user_realname.replaceAll(',', '、') : ''}}</c-field>
						<c-field icon="tf-field" label="预约时间">{{data.appointment_start_time}}</c-field>
						<c-field icon="tf-field" label="服务地址">{{data.customer_address}}</c-field>
						<member-icon v-if="data.charge_user_realname" class="person" circle :icon="data.charge_user_head_photo" :name="data.charge_user_realname" text></member-icon>
					</template>

					<template #operate>
						<c-button v-if="data.evaluate_state == 0" @click="mp.navigateWeb('/aftersales/appraise/edit', {id: data.id})">评价</c-button>
						<c-button v-else @click="globalDialog('appraiseDetail', {props: {id: data.id}})">查看评价</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'custom_order_evaluate',
		
		data() {
			return {
			}
		},

		computed: {
			...mapState(['evaluateTypeDic'])
		},

		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.person {
		position: absolute;
		right: .26rem;
		top: .8rem;
	}
</style>